import React from 'react';
import { TextField } from '@mui/material';

interface CommentsSectionProps {
  comments: string;
  onCommentsChange: (comments: string) => void;
  isSubmitting: boolean;
  readOnly: boolean;
}

export const CommentsSection: React.FC<CommentsSectionProps> = ({
  comments,
  onCommentsChange,
  isSubmitting,
  readOnly,
}) => (
  <TextField
    label="Comments (Optional)"
    value={comments}
    onChange={(e) => onCommentsChange(e.target.value)}
    disabled={isSubmitting || readOnly}
    fullWidth
    helperText="Additional comments about this decision"
  />
);

export default CommentsSection;
